// Import statements removed - all functionality is now in this file
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// Add any other JavaScript functionality here 

// Примеры использования прелоадера:
// window.preloader.show() - показать прелоадер
// window.preloader.hide() - скрыть прелоадер
// window.preloader.showFor(3000) - показать прелоадер на 3 секунды
// window.preloader.isActive() - проверить, активен ли прелоадер

// FAQ Accordion Functionality
function toggleAnswer(element) {
  const container = element.closest('.question-container');
  const answerContent = container.querySelector('.answer-content');
  const questionLabel = container.querySelector('.question-label');
  const icon = container.querySelector('.question-content-icon');
  
  // Close all other answers
  const allContainers = document.querySelectorAll('.question-container');
  allContainers.forEach(item => {
    if (item !== container) {
      const otherAnswer = item.querySelector('.answer-content');
      const otherLabel = item.querySelector('.question-label');
      if (otherAnswer) {
        otherAnswer.classList.remove('show');
      }
      if (otherLabel) {
        otherLabel.classList.remove('active');
      }
    }
  });
  
  // Toggle current answer
  if (answerContent) {
    answerContent.classList.toggle('show');
  }
  if (questionLabel) {
    questionLabel.classList.toggle('active');
  }
}

// --- Video Modal Logic ---
function openVideoModal(videoSrc) {
  const overlay = document.getElementById('video-modal-overlay');
  const modalContent = overlay.querySelector('.video-modal-content');
  // Удаляем старое видео, если есть
  const oldVideo = modalContent.querySelector('video');
  if (oldVideo) oldVideo.remove();
  // Создаём видео-элемент
  const video = document.createElement('video');
  video.src = videoSrc;
  video.controls = true;
  video.autoplay = true;
  video.style.background = '#000';
  video.style.display = 'block';
  video.style.maxWidth = '90vw';
  video.style.maxHeight = '80vh';
  overlay.style.display = 'flex';
  modalContent.appendChild(video);
  setTimeout(() => video.focus && video.focus(), 100);
  const closeBtn = modalContent.querySelector('.video-modal-close');
  closeBtn.onclick = closeVideoModal;
  // Закрытие по клику вне видео и вне кнопки
  overlay.onclick = function(e) {
    if (e.target === overlay) closeVideoModal();
  };
  // Предотвращаем всплытие клика с контента
  modalContent.onclick = function(e) {
    if (e.target === modalContent) return;
    e.stopPropagation();
  };
}
function closeVideoModal() {
  const overlay = document.getElementById('video-modal-overlay');
  const modalContent = overlay.querySelector('.video-modal-content');
  const video = modalContent.querySelector('video');
  if (video) {
    video.pause();
    video.currentTime = 0;
    video.remove();
  }
  overlay.style.display = 'none';
}
// --- END Video Modal Logic ---

// Модифицируем playVideo
function playVideo(videoId) {
  const video = document.getElementById(videoId);
  if (video) {
    const source = video.querySelector('source');
    if (source) {
      openVideoModal(source.src);
    }
  }
}
// Модифицируем playVideoSwiper аналогично
function playVideoSwiper(videoId) {
  const video = document.getElementById(videoId);
  if (video) {
    const source = video.querySelector('source');
    if (source) {
      openVideoModal(source.src);
    }
  }
}
// Для playVideoFromSlide
function playVideoFromSlide(playButton) {
  const slideContent = playButton.closest('.slide-content');
  const videoElement = slideContent.querySelector('.slide-video');
  if (!videoElement) {
    console.error('Video element not found in slide');
    return;
  }
  const source = videoElement.querySelector('source');
  if (source) {
    openVideoModal(source.src);
  }
}

// Video Slide Playback Functionality (для совместимости)
function playVideoSlide(slideIndex) {
  // Get the current active slide
  const swiper = document.querySelector('.video-swiper');
  if (swiper && swiper.swiper) {
    console.log(`Playing video for slide ${slideIndex}`);
    // Здесь можно добавить логику для воспроизведения конкретных видео
    // Пока просто показываем уведомление
    alert(`Воспроизведение видео для слайда ${slideIndex + 1}`);
    }
}

function resetSlideToImage(slideContent) {
  const videoElement = slideContent.querySelector('.slide-video');
  const imageElement = slideContent.querySelector('.review-image');
  const playButton = slideContent.querySelector('.play-button-overlay');
  
  if (videoElement) {
    videoElement.style.display = 'none';
    videoElement.pause();
    // Принудительно останавливаем звук
    videoElement.muted = true;
    videoElement.currentTime = 0;
  }
  
  if (imageElement) {
    imageElement.style.display = 'block';
  }
  
  if (playButton) {
    playButton.style.display = 'block';
  }
}

// Initialize Image Swiper
document.addEventListener('DOMContentLoaded', function() {
  // Инициализируем валидацию телефона
  if (window.initializePhoneValidation) {
    window.initializePhoneValidation();
  }
  
  // Add a small delay to ensure DOM is fully loaded
  setTimeout(() => {
    // Initialize image swiper if it exists
    const imageSwiperElement = document.querySelector('.video-swiper');
    const paginationElement = document.querySelector('.video-pagination .swiper-pagination');
    
    // Проверяем, есть ли видео-слайдер на странице
    if (!imageSwiperElement) {
      console.log('Video swiper element not found - skipping initialization');
    } else {
      console.log('Video swiper element:', imageSwiperElement);
      console.log('Video pagination element:', paginationElement);
      
      if (!paginationElement) {
        console.warn('Video Pagination element not found - swiper may not work properly');
      }
      
      const imageSwiper = new Swiper('.video-swiper', {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        width: null,
        height: null,
        autoHeight: true,
        pagination: {
          el: '.video-pagination .swiper-pagination',
          clickable: true,
          type: 'bullets',
          bulletElement: 'div',
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          renderBullet: function (index, className) {
            return '<div class="' + className + '"></div>';
          },
        },
        navigation: {
          nextEl: '.video-nav-right',
          prevEl: '.video-nav-left',
        },
        on: {
          init: function () {
            console.log('Video Swiper initialized');
            console.log('Total slides:', this.slides.length);
            if (this.pagination && this.pagination.bullets) {
              console.log('Pagination bullets:', this.pagination.bullets.length);
            }
          },
          slideChange: function () {
            console.log('Video slide changed to:', this.activeIndex);
            // Reset all slides to show images
            const allSlideContents = document.querySelectorAll('.slide-content');
            allSlideContents.forEach(slideContent => {
              resetSlideToImage(slideContent);
            });
          }
        }
      });
    }
    
    // Initialize amulet swiper if it exists
    const amuletSwiperElement = document.querySelector('.amulet-swiper');
    if (amuletSwiperElement) {
      console.log('Amulet swiper element found, initializing...');
      
      const amuletSwiper = new Swiper('.amulet-swiper', {
        modules: [Pagination, Navigation, Autoplay],
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        autoplay: {
          delay: 5000, // 5 секунд между сменой слайдов
          disableOnInteraction: false, // продолжать автопрокрутку после взаимодействия пользователя
        },
        navigation: {
          nextEl: '.amulet-button-next',
          prevEl: '.amulet-button-prev',
        },
        pagination: {
          el: '.amulet-pagination',
          clickable: true,
          type: 'bullets',
        },
        on: {
          init: function () {
            console.log('Amulet Swiper initialized');
            console.log('Total slides:', this.slides.length);
          },
        }
      });
    }
    
    // Add event listeners for play buttons (если они есть на странице)
    const playButtons = document.querySelectorAll('.play-button-overlay');
    if (playButtons.length > 0) {
      playButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          playVideoFromSlide(this);
        });
      });
    }
  }, 100); // 100ms delay
});

// Make functions globally available
window.toggleAnswer = toggleAnswer;
window.playVideo = playVideo;
window.playVideoSwiper = playVideoSwiper;
window.playVideoSlide = playVideoSlide;
window.playVideoFromSlide = playVideoFromSlide;

// Menu Toggle Functionality
function toggleMenu() {
  const menu = document.querySelector('.dropdown-menu');
  const body = document.body;
  
  if (menu) {
  if (menu.classList.contains('active')) {
    menu.classList.remove('active');
    body.style.overflow = 'auto';
  } else {
    menu.classList.add('active');
    body.style.overflow = 'hidden';
    }
  }
}

// Close menu when clicking outside
document.addEventListener('click', function(e) {
  const menu = document.querySelector('.dropdown-menu');
  const menuToggle = document.querySelector('.menu-toggle');
  
  if (menu && menuToggle && 
      menu.classList.contains('active') && 
      !menu.contains(e.target) && 
      !menuToggle.contains(e.target)) {
    toggleMenu();
  }
});

// Smooth scrolling for menu links
document.addEventListener('DOMContentLoaded', function() {
  const menuLinks = document.querySelectorAll('.menu-link');
  
  menuLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      
      // Если это внешняя ссылка (начинается с http или https), не блокируем
      if (href.startsWith('http://') || href.startsWith('https://')) {
        // Закрываем меню перед переходом
        toggleMenu();
        return; // Позволяем браузеру обработать ссылку
      }
      
      // Если это внутренняя якорная ссылка (начинается с #)
      if (href.startsWith('#')) {
        e.preventDefault();
        
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          // Close menu first
          toggleMenu();
          
          // Smooth scroll to target
          setTimeout(() => {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 300);
        }
      }
      // Для всех остальных ссылок (внутренние страницы) тоже не блокируем
    });
  });
});

// Make toggleMenu globally available
window.toggleMenu = toggleMenu; 

// Improved smooth scroll function for form
function smoothScrollToForm() {
  const el = document.querySelector('.root-inner10');
  if (el) {
    el.scrollIntoView({ block: 'start', behavior: 'instant' });
    setTimeout(() => {
      el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }, 50);
  }
}

// Make smoothScrollToForm globally available
window.smoothScrollToForm = smoothScrollToForm;


// Обработчик отправки формы
document.addEventListener('submit', function(event) {
  if (event.target && event.target.id === 'form') {
    if (window.preloader && window.preloader.show) {
  window.preloader.show();
    }
  //afValidated = false; // Или true, если валидация пройдена
  }
});

// Обработчик события af_complete (если используется какая-то библиотека форм)
document.addEventListener('af_complete', function(event) {
  const response = event.detail || event;
  const form = response.form;
  
  // Если у формы определённый id
  if (form && form.id === 'form') {
    console.log(response.deal);
    // редирект на страницу успешного заказа
    window.location.href = 'https://chakrawat.ru/success.html?dealid=' + response.deal;
  } else {
    console.log(response);
  }

  if (form && form.id === 'update') {
    form.style.display = 'none';
      // редирект на страницу успешного заказа
  } else {
    console.log(response);
  }
});

// Функция для обновления ширины прогресс-баров
function updateProgressBars() {
  const progressBars = document.querySelectorAll('.frame-child6[data-percent], .frame-child8[data-percent]');
  
  progressBars.forEach(bar => {
    const percentage = parseInt(bar.getAttribute('data-percent'));
    const maxWidth = 7.125; // Максимальная ширина в rem (ширина контейнера rectangle-parent)
    const calculatedWidth = (percentage / 100) * maxWidth;
    
    // Устанавливаем CSS переменную для ширины
    bar.style.setProperty('--progress-width', `${calculatedWidth}rem`);
  });
}

// Функция для установки процента конкретному прогресс-бару
function setProgressBarPercentage(selector, percentage) {
  const bar = document.querySelector(selector);
  if (bar) {
    bar.setAttribute('data-percent', percentage);
    updateProgressBars();
  }
}

// Функция для обновления всех процентов сразу
function updateAllProgressBars(percentages) {
  const progressBars = document.querySelectorAll('.frame-child6[data-percent], .frame-child8[data-percent]');
  
  progressBars.forEach((bar, index) => {
    if (percentages[index] !== undefined) {
      bar.setAttribute('data-percent', percentages[index]);
    }
  });
  
  updateProgressBars();
}

// Инициализация прогресс-баров при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
  updateProgressBars();
});

// Делаем функции глобально доступными
window.updateProgressBars = updateProgressBars;
window.setProgressBarPercentage = setProgressBarPercentage;
window.updateAllProgressBars = updateAllProgressBars;

// Функции для страницы эфиров
function initializeEthersPage() {
  // Обработчик кнопки "Назад"
  const backButton = document.querySelector('.back-button');
  if (backButton) {
    backButton.addEventListener('click', function() {
      window.history.back();
    });
  }

  // Обработчик раскрытия/скрытия контента эфира
  const titleContainers = document.querySelectorAll('.ether-title-container');
  titleContainers.forEach(container => {
    container.addEventListener('click', function() {
      // Находим соответствующий контент в том же родительском элементе
      const parentCard = this.closest('.main-ether-card');
      const content = parentCard ? parentCard.querySelector('.ether-content-collapsible') : null;
      const arrow = this.querySelector('.ether-arrow');
      
      if (content && arrow) {
        content.classList.toggle('expanded');
        arrow.classList.toggle('rotated');
      }
    });
  });

  // Обработчик кнопки "В избранное"
  const favoriteButtons = document.querySelectorAll('.favorite-button');
  favoriteButtons.forEach(button => {
    button.addEventListener('click', function() {
      this.classList.toggle('active');
      
      // Анимация сердца
      const heartIcon = this.querySelector('.heart-icon');
      if (this.classList.contains('active')) {
        heartIcon.style.transform = 'scale(1.2)';
        setTimeout(() => {
          heartIcon.style.transform = 'scale(1)';
        }, 200);
      }
    });
  });

  // Обработчик кнопок "Play"
  const playButtons = document.querySelectorAll('.play-button');
  playButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Здесь можно добавить логику воспроизведения видео
      console.log('Воспроизведение эфира');
      
      // Анимация кнопки
      this.style.transform = 'scale(0.95)';
      setTimeout(() => {
        this.style.transform = 'scale(1)';
      }, 150);
    });
  });


  // Обработчик навигационного меню (работает с .div5 и .menu-item)
  const menuItems = document.querySelectorAll('.div5, .menu-item');
  menuItems.forEach(item => {
    item.addEventListener('click', function() {
      // Убираем активный класс со всех элементов
      menuItems.forEach(menuItem => menuItem.classList.remove('active'));
      
      // Добавляем активный класс к текущему элементу
      this.classList.add('active');
      
      // Добавляем анимацию bounce при клике
      this.classList.add('bounce');
      setTimeout(() => {
        this.classList.remove('bounce');
      }, 600);
      
      // Здесь можно добавить логику навигации
      const menuText = this.querySelector('.div6, .div8, .menu-text');
      if (menuText) {
        console.log('Переход к:', menuText.textContent);
      }
    });
    
    // Добавляем эффект при наведении
    item.addEventListener('mouseenter', function() {
      if (!this.classList.contains('active')) {
        this.style.transform = 'translateY(-2px)';
      }
    });
    
    item.addEventListener('mouseleave', function() {
      if (!this.classList.contains('active')) {
        this.style.transform = 'translateY(0)';
      }
    });
    
    // Добавляем эффект при нажатии
    item.addEventListener('mousedown', function() {
      this.style.transform = 'translateY(-1px) scale(0.95)';
    });
    
    item.addEventListener('mouseup', function() {
      if (this.classList.contains('active')) {
        this.style.transform = 'translateY(-3px)';
      } else {
        this.style.transform = 'translateY(0)';
      }
    });
  });
}


// Функции для страницы "О сообществе"
function initializeAboutCommunityPage() {
  // Обработчик кнопки "Назад"
  const backButton = document.querySelector('.back-button');
  if (backButton) {
    backButton.addEventListener('click', function() {
      window.history.back();
    });
  }

  // Обработчик карточек
  const aboutCards = document.querySelectorAll('.about-card');
  aboutCards.forEach(card => {
    card.addEventListener('click', function() {
      const cardTitle = this.querySelector('.card-title').textContent;
      
      // Анимация при клике
      this.style.transform = 'scale(0.98)';
      setTimeout(() => {
        this.style.transform = '';
      }, 150);
      
      // Здесь можно добавить логику навигации для каждой карточки
      switch(cardTitle) {
        case 'Правила сообщества':
          console.log('Переход к правилам сообщества');
          // window.location.href = './rules.html';
          break;
        case 'Вопросы':
          console.log('Переход к FAQ');
          // window.location.href = './faq.html';
          break;
        case 'Служба заботы Пространства':
          console.log('Переход к службе поддержки');
          // window.location.href = './support.html';
          break;
        case 'Сообщить о нарушении':
          console.log('Переход к форме жалоб');
          // window.location.href = './report.html';
          break;
      }
    });
    
    // Добавляем эффект при наведении
    card.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
    });
    
    card.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });
}

// Инициализация страниц при загрузке
document.addEventListener('DOMContentLoaded', function() {
  // Проверяем, находимся ли мы на странице эфиров
  if (document.querySelector('.ethers-page')) {
    initializeEthersPage();
  }
  
  // Проверяем, находимся ли мы на странице "О сообществе"
  if (document.querySelector('.about-community-page')) {
    initializeAboutCommunityPage();
  }
});

// Делаем функции глобально доступными
window.initializeEthersPage = initializeEthersPage;

